export default __webpack_public_path__ + "static/kush-Me-362180746a7e7d796cb5252754075b9d.webp";